export default {

    lista: {
        method: 'get',
        url: 'contrato/trabalhador/lista'
    },
    pesquisa: {
        method: 'get',
        url: 'boletins/tabela/pesquisa{/id}'
    },
    cadastra: {
        method: 'post',
        url: 'contrato/trabalhador/cadastro'
    },
    delete: {
        method: 'delete',
        url: 'contrato/trabalhador/deletar{/id}'
    },
    editar: {
        method: 'get',
        url: 'contrato/trabalhador/editar{/id}'
    },
    update: {
        method: 'post',
        url: 'contrato/trabalhador/update'
    },
    update2206: {
        method: 'put',
        url: 'contrato/trabalhador/2206/update'
    },
    cadastra2206: {
        method: 'post',
        url: 'contrato/trabalhador/2206/cadastro'
    },
    update2306: {
        method: 'put',
        url: 'contrato/trabalhador/2306/update'
    },
    cadastra2306: {
        method: 'post',
        url: 'contrato/trabalhador/2306/cadastro'
    },
    delete2306: {
        method: 'delete',
        url: 'contrato/trabalhador/2306/deletar{/id}'
    },
    delete2206: {
        method: 'delete',
        url: 'contrato/trabalhador/2206/deletar{/id}'
    },
    show: {
        method: 'get',
        url: 'contrato/trabalhador/busca'
    },
    // pesquisa:{
    //     method:'get',
    //     url:'contrato/trabalhador/busca{/id}'
    // },
    showevento: {
        method: 'post',
        url: 'evento/show'
    },
}